import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Autocomplete from '@mui/material/Autocomplete';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Grid, FormControl, TextField, Divider } from '@mui/material';
import { getUser } from 'src/utils/Common';
import { base64Reader } from 'src/utils/storage/StrPhoto';
import { FileUploadList, FileUploadAdd } from './FileUploadSection';

const SessionUser = getUser();

const createFileObject = id => ({
  id,
  fileType: 0,
  fileName: '',
  fileSize: 0,
  fileData: null,
  fileDataType: '',
  fileSystem: 0,
  fileLastModifiedDate: '',
  fileDataSize: 0,
  active: 1,
  fromDb: 0
});

function ProjectUpdate({
  data,
  setData,
  projectFiles,
  setProjectFiles,
  errors,
  setErrors,
  checkRolesAuth,
  fileLoading,
  setFileLoading
}) {
  const [durum, setDurum] = React.useState([]);
  const [merkeziKlima, setMerkemziKlima] = React.useState([]);
  const [fileTypes, setFileTypes] = React.useState([]);
  const [dataMinValues, setDataMinValues] = useState([]);
  const [oneTime, setOneTime] = useState(true);
  useEffect(() => {
    try {
      if (oneTime) {
        const mainArray = JSON.parse(
          localStorage.getItem('HavcComboData').replace(/\\"/g, '"')
        );
        setDurum(mainArray[0].DURUM);
        setMerkemziKlima(mainArray[0].MERKEZI_KLIMALAR);
        setFileTypes(mainArray[0].DOSYA_TIPLERI);
      }
      if (data && data.length > 0 && oneTime) {
        setDataMinValues([...data]);
        setOneTime(false);
      }
    } catch {
      // Uyari ust bilesende (UpdateProjectDialog) gosteriliyor.
    }
  }, [data]);

  const getAccordionStyles = () => ({
    border: '1px solid #494747',
    borderRadius: '4px',
    marginBottom: '8px',
    marginTop: '8px'
  });

  const getLabel = (pID, currentLevel, i) => {
    const index = data.filter(x => x.Level === currentLevel).length + 1 + i;

    switch (currentLevel) {
      case 0:
        return `Merkezi Kumanda-${parseInt(index)}`;
      case 1:
        return `Sistem-${parseInt(index)}`;
      case 2:
        return `ODU-${parseInt(index)}`;
      case 3:
        return `IDU-${parseInt(index)}`;
      default:
        return `Label-${index}`;
    }
  };

  const handleOnChange = (Id, prop, newVal, selectedItem) => {
    let newValue;
    if (newVal) {
      newValue = newVal?.Id ? newVal?.Id : newVal;
    }
    if (prop === 'ChildCount') {
      const lastVal = parseInt(data.filter(x => x.Id === Id)[0]?.ChildCount);
      const newValInt = parseInt(newVal);
      const lastElementId = Math.max(
        ...data
          .filter(item => item.ParentID === Id && item.LineStatus !== 'D')
          .map(item => item.Id),
        0
      );

      if (lastVal > parseInt(newVal)) {
        setData(prevData =>
          prevData.map(item =>
            item.Id === Id ? { ...item, [prop]: newValue } : item
          )
        );
        const idsToDelete = data
          .filter(item => item.ParentID === selectedItem.Id)
          .sort((a, b) => b.Id - a.Id)
          .slice(0, lastVal - newValInt)
          .map(item => ({ Id: item.Id, LineStatus: item.LineStatus }));

        idsToDelete.forEach(item =>
          handleDelete(item.Id, prop, newValue, item.LineStatus)
        );
      } else {
        setData(prevData =>
          prevData.map(item =>
            item.Id === Id
              ? {
                ...item,
                [prop]: newValue,
                LineStatus: item.LineStatus === 'A' ? 'A' : 'U'
              }
              : item
          )
        );
        const arrLength =
          parseInt(newVal) -
          parseInt(
            data.find(x => x.Id === Id && x.LineStatus !== 'D').ChildCount
          );
        const newElementId =
          data && data.length > 0
            ? Math.max(...data.map(item => item.Id, 0)) + 1
            : 1;
        const newObjects = Array.from(
          { length: parseInt(arrLength) },
          (_, index) => ({
            Id: newElementId + index + 1,
            ParentID: selectedItem.Id,
            ProjectID: selectedItem.ProjectID,
            FisNo: 0,
            ModelCode: 0,
            Level: selectedItem.Level + 1,
            LineStatus: 'A',
            SystemName: getLabel(
              selectedItem.Id,
              selectedItem.Level + 1,
              index
            ),
            CommissioningDate: '',
            DryContactCount: 0,
            DxCount: 0,
            FreshAirCount: 0,
            FreshAirDxCount: 0,
            FrontPanelCount: 0,
            HrBoxCount: 0,
            HydrocideCount: 0,
            RemoteCount: 0,
            SystemCapacity: 0,
            SystemStatus: 0,
            Description: '',
            Icmal17: 0,
            Icmal18: 0,
            Icmal19: 0,
            Icmal20: 0,
            Icmal21: 0,
            Icmal22: 0,
            Icmal23: 0,
            Icmal24: 0,
            Icmal25: 0,
            Icmal26: 0,
            Icmal36: 0,
            Modifier: SessionUser?.UserId ? SessionUser?.UserId : 0,
            ChildCount: 0
          })
        );

        setData(prev => [...prev, ...newObjects]);
      }
    } else {
      setData(prevData =>
        prevData.map(item =>
          item.Id === Id
            ? {
              ...item,
              [prop]: newValue,
              LineStatus: item.LineStatus === 'A' ? 'A' : 'U'
            }
            : item
        )
      );
    }
  };

  const handleDelete = parentId => {
    const deleteNode = id => {
      const _lineStatus = data.find(item => item.Id === id).LineStatus;
      if (_lineStatus !== 'A') {
        setData(prevData =>
          prevData.map(item =>
            item.Id === id
              ? {
                ...item,
                LineStatus: 'D'
              }
              : item
          )
        );
      } else {
        setData(prevData => prevData.filter(item => item.Id !== id));
        const children = data.filter(item => item.DerivationFrom === id);
        children.forEach(child => deleteNode(child.Id));
      }

      const children = data.filter(item => item.DerivationFrom === id);
      children.forEach(child => deleteNode(child.Id));
    };

    const parentNode = data.find(item => item.Id === parentId);
    if (parentNode) {
      deleteNode(parentId);
    }
  };

  const handleChange = (id, property, value, type, minVal, decreaseCheck) => {
    if (type === 'auto') {
      setData(prevItems =>
        prevItems.map(item =>
          item.Id === id
            ? {
              ...item,
              [property]: value ? value.Id : 0,
              LineStatus: item.LineStatus === 'A' ? 'A' : 'U'
            }
            : item
        )
      );
    }
    if (type === 'text') {
      setData(prevItems =>
        prevItems.map(item => {
          if (item.Id === id) {
            let updatedItem = {
              ...item,
              [property]: value,
              LineStatus: item.LineStatus === 'A' ? 'A' : 'U'
            };
            if (
              decreaseCheck === 'decreaseCheck' &&
              parseInt(value == "" ? 0 : value) <= parseInt(minVal)
            ) {
              updatedItem = { ...item, [property]: minVal, LineStatus: 'N' };
            }

            if (
              property === 'AdditionalGasAmount' ||
              property === 'PreGasAmount'
            ) {
              const additionalGas =
                property === 'AdditionalGasAmount'
                  ? value
                  : item.AdditionalGasAmount;
              const preGas =
                property === 'PreGasAmount' ? value : item.PreGasAmount;
              updatedItem.SystemTotalGas =
                (Math.round((parseFloat(additionalGas) + parseFloat(preGas)) * 10) / 10);
            }

            return updatedItem;
          }
          return item;
        })
      );
    }
  };

  const systemRepeat = (newValue, oldValue, item, minVal) => {
    if (newValue < oldValue) {
      const idsToDelete = data
        .filter(x => x.Level === item.Level && x.DerivationFrom === item.Id)
        .sort((a, b) => b.Id - a.Id)
        .slice(0, oldValue - (newValue < minVal ? minVal : newValue))
        .map(item => item.Id);

      idsToDelete.forEach(id => handleDelete(id));
    } else {
      const arrLength =
        newValue -
        data.filter(x => x.Level == item.Level && x.DerivationFrom === item.Id)
          .length;
      const newElementId =
        data && data.length > 0 ? Math.max(...data.map(item => item.Id)) : 0;
      const newObjects = Array.from(
        { length: parseInt(arrLength - 1) },
        (_, index) => ({
          AdditionalGasAmount: parseFloat(item.AdditionalGasAmount),
          AirRouterCount: item.AirRouterCount,
          BranchCollectorCount: item.BranchCollectorCount,
          Cable12_7mm: parseFloat(item.Cable12_7mm),
          Cable15_88mm: parseFloat(item.Cable15_88mm),
          Cable19_05mm: parseFloat(item.Cable19_05mm),
          Cable22_22mm: parseFloat(item.Cable22_22mm),
          Cable25_4mm: parseFloat(item.Cable25_4mm),
          Cable28_88mm: parseFloat(item.Cable28_88mm),
          Cable34_92mm: parseFloat(item.Cable34_92mm),
          Cable41_28mm: parseFloat(item.Cable41_28mm),
          Cable6_35mm: parseFloat(item.Cable6_35mm),
          Cable9_52mm: parseFloat(item.Cable9_52mm),
          CommissioningDate: item.CommissioningDate,
          ControlRoomModel: item.ControlRoomModel,
          ControlRoomModelNote: item.ControlRoomModelNote,
          Creator: SessionUser?.UserId ? SessionUser?.UserId : 0,
          DerivationFrom: item.Id,
          DryContactCount: item.DryContactCount,
          DxCount: item.DxCount,
          EevKitCount: item.EevKitCount,
          FdxBoxCount: item.FdxBoxCount,
          FisNo: item.FisNo,
          FreshAirCount: item.FreshAirCount,
          FreshAirDxCount: item.FreshAirDxCount,
          FrontPanelCount: item.FrontPanelCount,
          HeatPumpCount: item.HeatPumpCount,
          HrBoxCount: item.HrBoxCount,
          HydrocideCount: item.HydrocideCount,
          Id: newElementId + index + 1,
          IduCount: item.IduCount,
          IntegrationModuleCount: item.IntegrationModuleCount,
          KsCommunicationKitCount: item.KsCommunicationKitCount,
          KsDxCount: item.KsDxCount,
          Level: item.Level,
          LineStatus: 'A',
          Modifier: SessionUser?.UserId ? SessionUser?.UserId : 0,
          OduCount: item.OduCount,
          OdiCount: item.PdiCount,
          PreGasAmount: parseFloat(item.PreGasAmount),
          ProjectID: item.ProjectID,
          RemoteCount: item.RemoteCount,
          SystemCapacity: parseFloat(item.SystemCapacity),
          SystemControlRoomModel: item.SystemControlRoomModel,
          SystemName: getLabel(0, item.Level, index),
          SystemNote: item.SystemNote,
          SystemRepeatCount: 1,
          SystemStatus: item.SystemStatus,
          SystemTotalGas: parseFloat(item.SystemTotalGas)
        })
      );

      setData(prev => [...prev, ...newObjects]);
    }
  };

  const handleAddFile = () => {
    const lastId =
      projectFiles.length > 0
        ? projectFiles.reduce(
          (max, item) => (item.id > max ? item.id : max),
          projectFiles[0].id
        )
        : 1;

    const newFile = createFileObject(lastId + 1);
    setProjectFiles([...projectFiles, newFile]);
  };

  const handleFiles = async (newFiles, Id) => {
    let base64Result = '';
    base64Result = await base64Reader(newFiles.file);

    const updatedFiles = projectFiles.map(file => {
      if (file.id === Id) {
        return {
          ...file,
          id: file.id,
          fileName: newFiles.file.name,
          fileData: base64Result,
          fileDataType: newFiles.file.type,
          fileDataSize: newFiles.file.size,
          fileLastModifiedDate: newFiles.file.lastModifiedDate,
          active: 1,
          fromDb: 0
        };
      }
      return file;
    });

    setProjectFiles(updatedFiles);
  };

  const handleDownload = (fileData, fileName) => {
    const link = document.createElement('a');
    link.href = `data:application/octet-stream;base64,${fileData}`;
    link.download = fileName;
    link.click();
  };

  return (
    <React.Fragment>
      <Accordion key={'PD'} style={getAccordionStyles()}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography sx={{ width: '33%', flexShrink: 0 }}>
            Proje Dağılımı
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid size={12}>
              {/* Merkezi Kumanda Creation */}
              {data.filter(item => item.Level === 0 && item.LineStatus !== 'D').length > 0 ? (
                <Accordion key={'MK'} style={getAccordionStyles()}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ width: '33%', flexShrink: 0 }}>
                      Merkezi Kumanda Bilgisi
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      {data
                        .filter(x => x.Level === 0 && x.LineStatus !== 'D')
                        .map(item => (
                          <React.Fragment key={item.Id}>
                            <Grid size={4}>
                              <FormControl fullWidth>
                                <Autocomplete
                                  id="ControlRoomModel"
                                  name="ControlRoomModel"
                                  fullWidth
                                  disabled={!checkRolesAuth('ControlRoomModel')}
                                  options={merkeziKlima}
                                  value={
                                    merkeziKlima.find(
                                      x => x.Id === item.ControlRoomModel
                                    ) || null
                                  }
                                  onChange={(event, value) =>
                                    handleChange(
                                      item.Id,
                                      'ControlRoomModel',
                                      value,
                                      'auto'
                                    )
                                  }
                                  getOptionLabel={option =>
                                    option.Dsc ? option.Dsc : ''
                                  }
                                  renderInput={params => (
                                    <TextField
                                      {...params}
                                      label="Merkezi Kumanda Modeli"
                                      variant="outlined"
                                    />
                                  )}
                                />
                              </FormControl>
                            </Grid>
                            <Grid size={8}>
                              <FormControl fullWidth>
                                <TextField
                                  id="ControlRoomModelNote"
                                  name="ControlRoomModelNote"
                                  variant="outlined"
                                  multiline
                                  minRows={1}
                                  placeholder="Açıklama"
                                  disabled={
                                    !checkRolesAuth('ControlRoomModelNote')
                                  }
                                  value={item.ControlRoomModelNote}
                                  onChange={event =>
                                    handleChange(
                                      item.Id,
                                      'ControlRoomModelNote',
                                      event.target.value,
                                      'text'
                                    )
                                  }
                                />
                              </FormControl>
                            </Grid>
                          </React.Fragment>
                        ))}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ) : (
                <></>
              )}
            </Grid>
            {/* Boru Metraj ve Gaz Creation */}
            <Grid size={12}>
              {data.filter(x => x.Level === 1).length > 0 ? (
                <Accordion key={'BG'} style={getAccordionStyles()}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography sx={{ width: '33%', flexShrink: 0 }}>
                      Boru Metraj ve Gaz Miktarı
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid size={12}>
                      {data.slice(0, 1).map(item => (
                        <React.Fragment key={item.Id}>
                          <Grid container spacing={2}>
                            <Grid size={3}>
                              <FormControl fullWidth>
                                <TextField
                                  id="Cable6_35mm"
                                  name="Cable6_35mm"
                                  label="6.35 mm"
                                  type="number"
                                  variant="outlined"
                                  disabled={!checkRolesAuth('Cable6_35mm')}
                                  value={item.Cable6_35mm}
                                  onChange={event =>
                                    handleChange(
                                      item.Id,
                                      'Cable6_35mm',
                                      parseFloat(event.target.value),
                                      'text'
                                    )
                                  }
                                />
                              </FormControl>
                            </Grid>
                            <Grid size={3}>
                              <FormControl fullWidth>
                                <TextField
                                  id="Cable9_52mm"
                                  name="Cable9_52mm"
                                  label="9.52 mm"
                                  type="number"
                                  variant="outlined"
                                  disabled={!checkRolesAuth('Cable9_52mm')}
                                  value={item.Cable9_52mm}
                                  onChange={event =>
                                    handleChange(
                                      item.Id,
                                      'Cable9_52mm',
                                      parseFloat(event.target.value),
                                      'text'
                                    )
                                  }
                                />
                              </FormControl>
                            </Grid>
                            <Grid size={3}>
                              <FormControl fullWidth>
                                <TextField
                                  id="Cable12_7mm"
                                  name="Cable12_7mm"
                                  label="12.7mm"
                                  type="number"
                                  variant="outlined"
                                  disabled={!checkRolesAuth('Cable12_7mm')}
                                  value={item.Cable12_7mm}
                                  onChange={event =>
                                    handleChange(
                                      item.Id,
                                      'Cable12_7mm',
                                      parseFloat(event.target.value),
                                      'text'
                                    )
                                  }
                                />
                              </FormControl>
                            </Grid>
                            <Grid size={3}>
                              <FormControl fullWidth>
                                <TextField
                                  id="Cable15_88mm"
                                  name="Cable15_88mm"
                                  label="15.88 mm"
                                  type="number"
                                  variant="outlined"
                                  disabled={!checkRolesAuth('Cable15_88mm')}
                                  value={item.Cable15_88mm}
                                  onChange={event =>
                                    handleChange(
                                      item.Id,
                                      'Cable15_88mm',
                                      parseFloat(event.target.value),
                                      'text'
                                    )
                                  }
                                />
                              </FormControl>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid size={3}>
                              <FormControl fullWidth>
                                <TextField
                                  id="Cable19_05mm"
                                  name="Cable19_05mm"
                                  label="19.05 mm"
                                  type="number"
                                  variant="outlined"
                                  disabled={!checkRolesAuth('Cable19_05mm')}
                                  value={item.Cable19_05mm}
                                  onChange={event =>
                                    handleChange(
                                      item.Id,
                                      'Cable19_05mm',
                                      parseFloat(event.target.value),
                                      'text'
                                    )
                                  }
                                />
                              </FormControl>
                            </Grid>
                            <Grid size={3}>
                              <FormControl fullWidth>
                                <TextField
                                  id="Cable22_22mm"
                                  name="Cable22_22mm"
                                  label="22.22 mm"
                                  type="number"
                                  variant="outlined"
                                  disabled={!checkRolesAuth('Cable22_22mm')}
                                  value={item.Cable22_22mm}
                                  onChange={event =>
                                    handleChange(
                                      item.Id,
                                      'Cable22_22mm',
                                      parseFloat(event.target.value),
                                      'text'
                                    )
                                  }
                                />
                              </FormControl>
                            </Grid>
                            <Grid size={3}>
                              <FormControl fullWidth>
                                <TextField
                                  id="Cable25_4mm"
                                  name="Cable25_4mm"
                                  label="25.4 mm"
                                  type="number"
                                  variant="outlined"
                                  disabled={!checkRolesAuth('Cable25_4mm')}
                                  value={item.Cable25_4mm}
                                  onChange={event =>
                                    handleChange(
                                      item.Id,
                                      'Cable25_4mm',
                                      parseFloat(event.target.value),
                                      'text'
                                    )
                                  }
                                />
                              </FormControl>
                            </Grid>
                            <Grid size={3}>
                              <FormControl fullWidth>
                                <TextField
                                  id="Cable28_88mm"
                                  name="Cable28_88mm"
                                  label="28.88 mm"
                                  type="number"
                                  variant="outlined"
                                  disabled={!checkRolesAuth('Cable28_88mm')}
                                  value={item.Cable28_88mm}
                                  onChange={event =>
                                    handleChange(
                                      item.Id,
                                      'Cable28_88mm',
                                      parseFloat(event.target.value),
                                      'text'
                                    )
                                  }
                                />
                              </FormControl>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2}>
                            <Grid size={3}>
                              <FormControl fullWidth>
                                <TextField
                                  id="Cable34_92mm"
                                  name="Cable34_92mm"
                                  label="34.92 mm"
                                  type="number"
                                  variant="outlined"
                                  disabled={!checkRolesAuth('Cable34_92mm')}
                                  value={item.Cable34_92mm}
                                  onChange={event =>
                                    handleChange(
                                      item.Id,
                                      'Cable34_92mm',
                                      parseFloat(event.target.value),
                                      'text'
                                    )
                                  }
                                />
                              </FormControl>
                            </Grid>
                            <Grid size={3}>
                              <FormControl fullWidth>
                                <TextField
                                  id="Cable41_28mm"
                                  name="Cable41_28mm"
                                  label="41.28 mm"
                                  type="number"
                                  variant="outlined"
                                  disabled={!checkRolesAuth('Cable41_28mm')}
                                  value={item.Cable41_28mm}
                                  onChange={event =>
                                    handleChange(
                                      item.Id,
                                      'Cable41_28mm',
                                      parseFloat(event.target.value),
                                      'text'
                                    )
                                  }
                                />
                              </FormControl>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      ))}
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              ) : (
                <></>
              )}
            </Grid>
            <Grid size={12}>
              {/* Sistem Creation */}
              {data.filter(item => item.Level === 1 && item.LineStatus !== 'D')
                .length > 0 ? (
                data
                  .filter(x => x.Level === 1 && x.LineStatus !== 'D')
                  .map(item => (
                    <Accordion
                      key={'System-' + item.Id}
                      style={getAccordionStyles()}
                    >
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography sx={{ width: '33%', flexShrink: 0 }}>
                          {item.SystemName}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2}>
                          <Grid size={8}>
                            <FormControl fullWidth>
                              <TextField
                                id="SystemName"
                                name="SystemName"
                                label="Sistem Adı"
                                variant="outlined"
                                disabled={!checkRolesAuth('SystemName')}
                                multiline
                                minRows={1}
                                value={item.SystemName}
                                onChange={event =>
                                  handleChange(
                                    item.Id,
                                    'SystemName',
                                    event.target.value,
                                    'text'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid>
                          {/* <Grid item xs={4}>
                            <FormControl fullWidth>
                              <Autocomplete
                                id="SystemControlRoomModel"
                                name="SystemControlRoomModel"
                                label="Sistem Merkezi Kumandası"
                                fullWidth
                                options={merkeziKlima}
                                getOptionLabel={option =>
                                  option.Dsc ? option.Dsc : ''
                                }
                                renderInput={params => (
                                  <TextField
                                    {...params}
                                    label="Merkezi Kumanda Modeli"
                                    variant="outlined"
                                  />
                                )}
                                value={
                                  merkeziKlima.find(
                                    x => x.Id === item.SystemControlRoomModel
                                  ) || null
                                }
                                onChange={(event, value) =>
                                  handleChange(
                                    item.Id,
                                    'SystemControlRoomModel',
                                    value,
                                    'auto'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid> */}
                          <Grid size={4}>
                            <FormControl fullWidth>
                              <TextField
                                id="SystemRepeatCount"
                                name="SystemRepeatCount"
                                label="Sistem Tekrar Sayısı"
                                type="number"
                                variant="outlined"
                                disabled={!checkRolesAuth('SystemRepeatCount')}
                                value={item.SystemRepeatCount}
                                onChange={event => {
                                  handleChange(
                                    item.Id,
                                    'SystemRepeatCount',
                                    event.target.value,
                                    'text',
                                    dataMinValues?.find(x => x.Id === item.Id)
                                      ?.SystemRepeatCount,
                                    'decreaseCheck'
                                  );
                                  systemRepeat(
                                    parseInt(event.target.value),
                                    parseInt(item.SystemRepeatCount),
                                    item,
                                    dataMinValues?.find(x => x.Id === item.Id)
                                      ?.SystemRepeatCount
                                  );
                                }}
                              />
                            </FormControl>
                          </Grid>
                          <Grid size={2}>
                            <FormControl fullWidth>
                              <TextField
                                id="PreGasAmount"
                                name="PreGasAmount"
                                label="Ön Gaz Miktarı"
                                type="number"
                                variant="outlined"
                                disabled={!checkRolesAuth('PreGasAmount')}
                                value={item.PreGasAmount}
                                onChange={event =>
                                  handleChange(
                                    item.Id,
                                    'PreGasAmount',
                                    parseFloat(event.target.value),
                                    'text'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid>
                          <Grid size={2}>
                            <FormControl fullWidth>
                              <TextField
                                id="AdditionalGasAmount"
                                name="AdditionalGasAmount"
                                label="Ek Gaz Miktarı"
                                type="number"
                                variant="outlined"
                                disabled={
                                  !checkRolesAuth('AdditionalGasAmount')
                                }
                                value={item.AdditionalGasAmount}
                                onChange={event =>
                                  handleChange(
                                    item.Id,
                                    'AdditionalGasAmount',
                                    parseFloat(event.target.value),
                                    'text'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid>
                          <Grid size={2}>
                            <FormControl fullWidth>
                              <TextField
                                id="SystemCapacity"
                                name="SystemCapacity"
                                label="Sistem Kapasitesi"
                                type="number"
                                variant="outlined"
                                disabled={!checkRolesAuth('SystemCapacity')}
                                value={item.SystemCapacity}
                                onChange={event =>
                                  handleChange(
                                    item.Id,
                                    'SystemCapacity',
                                    parseFloat(event.target.value),
                                    'text'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid>
                          <Grid size={2}>
                            <FormControl fullWidth>
                              <TextField
                                id="SystemTotalGas"
                                name="SystemTotalGas"
                                label="Sistem Toplam Gaz Miktarı"
                                type="number"
                                variant="outlined"
                                value={
                                  (Math.round((parseFloat(item.PreGasAmount) + parseFloat(item.AdditionalGasAmount)) * 10) / 10)
                                }
                                disabled={true}
                              />
                            </FormControl>
                          </Grid>
                          <Grid size={2}>
                            <FormControl fullWidth>
                              <Autocomplete
                                id="SystemStatus"
                                name="SystemStatus"
                                label="Sistemin Durumu"
                                disabled={!checkRolesAuth('SystemStatus')}
                                fullWidth
                                options={durum}
                                getOptionLabel={option =>
                                  option.Dsc ? option.Dsc : ''
                                }
                                renderInput={params => (
                                  <TextField
                                    {...params}
                                    label="Sistem Durumu"
                                    variant="outlined"
                                  />
                                )}
                                value={
                                  durum.find(x => x.Id === item.SystemStatus) ||
                                  null
                                }
                                onChange={(event, value) =>
                                  handleChange(
                                    item.Id,
                                    'SystemStatus',
                                    value,
                                    'auto'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid>
                          <Grid size={2}>
                            <FormControl fullWidth>
                              <TextField
                                id="CommissioningDate"
                                name="CommissioningDate"
                                label="Devreye Alım Tarihi"
                                variant="outlined"
                                type="date"
                                disabled={!checkRolesAuth('CommissioningDate')}
                                InputLabelProps={{
                                  shrink: true,
                                  required: true
                                }}
                                value={item?.CommissioningDate?.split('T')[0]}
                                onChange={event =>
                                  handleChange(
                                    item.Id,
                                    'CommissioningDate',
                                    event.target.value.includes('T')
                                      ? event.target.value
                                      : event.target.value + 'T00:00:00',
                                    'text'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid>
                          <Grid size={12}>
                            <Divider />
                          </Grid>
                          {/* İç-Dış Ünite Bilgileri */}
                          <Grid size={12}>
                            <Accordion
                              key={item.SystemName + '-UN'}
                              style={getAccordionStyles()}
                            >
                              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography
                                  sx={{ width: '33%', flexShrink: 0 }}
                                >
                                  İç-Dış Ünite Bilgileri
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid size={12}>
                                  <Grid container spacing={2}>
                                    <Grid size={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="OduCount"
                                          name="OduCount"
                                          label="ODU Adet"
                                          type="number"
                                          variant="outlined"
                                          disabled={!checkRolesAuth('OduCount')}
                                          error={Boolean(
                                            errors[`OduCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`OduCount${item.Id}`]
                                          }
                                          value={item.OduCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'OduCount',
                                              event.target.value,
                                              'text',
                                              dataMinValues?.find(
                                                x => x.Id === item.Id
                                              )?.OduCount,
                                              'decreaseCheck'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid size={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="IduCount"
                                          name="IduCount"
                                          label="IDU Adet"
                                          type="number"
                                          variant="outlined"
                                          disabled={!checkRolesAuth('IduCount')}
                                          error={Boolean(
                                            errors[`IduCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`IduCount${item.Id}`]
                                          }
                                          value={item.IduCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'IduCount',
                                              event.target.value,
                                              'text',
                                              dataMinValues?.find(
                                                x => x.Id === item.Id
                                              )?.IduCount,
                                              'decreaseCheck'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid size={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="HydrocideCount"
                                          name="HydrocideCount"
                                          label="Hidrokit Adet"
                                          type="number"
                                          variant="outlined"
                                          disabled={
                                            !checkRolesAuth('HydrocideCount')
                                          }
                                          error={Boolean(
                                            errors[`HydrocideCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`HydrocideCount${item.Id}`]
                                          }
                                          value={item.HydrocideCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'HydrocideCount',
                                              event.target.value,
                                              'text',
                                              dataMinValues?.find(
                                                x => x.Id === item.Id
                                              )?.HydrocideCount,
                                              'decreaseCheck'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                  <Grid container spacing={2}>
                                    <Grid size={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="KsDxCount"
                                          name="KsDxCount"
                                          label="KS Dx Adet"
                                          type="number"
                                          variant="outlined"
                                          disabled={
                                            !checkRolesAuth('KsDxCount')
                                          }
                                          value={item.KsDxCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'KsDxCount',
                                              event.target.value,
                                              'text'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid size={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="RemoteCount"
                                          name="RemoteCount"
                                          label="Kumanda Adet"
                                          type="number"
                                          variant="outlined"
                                          disabled={
                                            !checkRolesAuth('RemoteCount')
                                          }
                                          error={Boolean(
                                            errors[`RemoteCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`RemoteCount${item.Id}`]
                                          }
                                          value={item.RemoteCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'RemoteCount',
                                              event.target.value,
                                              'text',
                                              dataMinValues?.find(
                                                x => x.Id === item.Id
                                              )?.RemoteCount,
                                              'decreaseCheck'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid size={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="FreshAirDxCount"
                                          name="FreshAirDxCount"
                                          label="Taze Hava DX Adet"
                                          type="number"
                                          variant="outlined"
                                          disabled={
                                            !checkRolesAuth('FreshAirDxCount')
                                          }
                                          value={item.FreshAirDxCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'FreshAirDxCount',
                                              event.target.value,
                                              'text',
                                              dataMinValues?.find(
                                                x => x.Id === item.Id
                                              )?.FreshAirDxCount,
                                              'decreaseCheck'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                  <Grid container spacing={2}>
                                    <Grid size={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="FrontPanelCount"
                                          name="FrontPanelCount"
                                          label="Ön Panel Adet"
                                          type="number"
                                          variant="outlined"
                                          disabled={
                                            !checkRolesAuth('FrontPanelCount')
                                          }
                                          error={Boolean(
                                            errors[`FrontPanelCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`FrontPanelCount${item.Id}`]
                                          }
                                          value={item.FrontPanelCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'FrontPanelCount',
                                              event.target.value,
                                              'text',
                                              dataMinValues?.find(
                                                x => x.Id === item.Id
                                              )?.FrontPanelCount,
                                              'decreaseCheck'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid size={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="HrBoxCount"
                                          name="HrBoxCount"
                                          label="HR Box Adet"
                                          type="number"
                                          variant="outlined"
                                          disabled={
                                            !checkRolesAuth('HrBoxCount')
                                          }
                                          error={Boolean(
                                            errors[`HrBoxCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`HrBoxCount${item.Id}`]
                                          }
                                          value={item.HrBoxCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'HrBoxCount',
                                              event.target.value,
                                              'text',
                                              dataMinValues?.find(
                                                x => x.Id === item.Id
                                              )?.HrBoxCount,
                                              'decreaseCheck'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid size={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="IntegrationModuleCount"
                                          name="IntegrationModuleCount"
                                          label="Entegrasyon Modül Adet"
                                          type="number"
                                          variant="outlined"
                                          disabled={
                                            !checkRolesAuth(
                                              'IntegrationModuleCount'
                                            )
                                          }
                                          error={Boolean(
                                            errors[
                                            `IntegrationModuleCount${item.Id}`
                                            ]
                                          )}
                                          helperText={
                                            errors[
                                            `IntegrationModuleCount${item.Id}`
                                            ]
                                          }
                                          value={item.IntegrationModuleCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'IntegrationModuleCount',
                                              event.target.value,
                                              'text',
                                              dataMinValues?.find(
                                                x => x.Id === item.Id
                                              )?.IntegrationModuleCount,
                                              'decreaseCheck'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                  <Grid container spacing={2}>
                                    <Grid size={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="KsCommunicationKitCount"
                                          name="KsCommunicationKitCount"
                                          label="Ks Haberleşme Kit Adet"
                                          type="number"
                                          variant="outlined"
                                          disabled={
                                            !checkRolesAuth(
                                              'KsCommunicationKitCount'
                                            )
                                          }
                                          error={Boolean(
                                            errors[
                                            `KsCommunicationKitCount${item.Id}`
                                            ]
                                          )}
                                          helperText={
                                            errors[
                                            `KsCommunicationKitCount${item.Id}`
                                            ]
                                          }
                                          value={item.KsCommunicationKitCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'KsCommunicationKitCount',
                                              event.target.value,
                                              'text',
                                              dataMinValues?.find(
                                                x => x.Id === item.Id
                                              )?.KsCommunicationKitCount,
                                              'decreaseCheck'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid size={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="EevKitCount"
                                          name="EevKitCount"
                                          label="Eev Kit Adet"
                                          type="number"
                                          variant="outlined"
                                          disabled={
                                            !checkRolesAuth('EevKitCount')
                                          }
                                          error={Boolean(
                                            errors[`EevKitCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`EevKitCount${item.Id}`]
                                          }
                                          value={item.EevKitCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'EevKitCount',
                                              event.target.value,
                                              'text',
                                              dataMinValues?.find(
                                                x => x.Id === item.Id
                                              )?.EevKitCount,
                                              'decreaseCheck'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid size={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="FdxBoxCount"
                                          name="FdxBoxCount"
                                          label="FDX Kutu Adet"
                                          type="number"
                                          variant="outlined"
                                          disabled={
                                            !checkRolesAuth('FdxBoxCount')
                                          }
                                          error={Boolean(
                                            errors[`FdxBoxCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`FdxBoxCount${item.Id}`]
                                          }
                                          value={item.FdxBoxCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'FdxBoxCount',
                                              event.target.value,
                                              'text',
                                              dataMinValues?.find(
                                                x => x.Id === item.Id
                                              )?.FdxBoxCount,
                                              'decreaseCheck'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                  <Grid container spacing={2}>
                                    <Grid size={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="BranchCollectorCount"
                                          name="BranchCollectorCount"
                                          label="Branşman/Kolektör Adet"
                                          type="number"
                                          variant="outlined"
                                          disabled={
                                            !checkRolesAuth(
                                              'BranchCollectorCount'
                                            )
                                          }
                                          value={item.BranchCollectorCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'BranchCollectorCount',
                                              event.target.value,
                                              'text',
                                              dataMinValues?.find(
                                                x => x.Id === item.Id
                                              )?.BranchCollectorCount,
                                              'decreaseCheck'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                    <Grid size={4}>
                                      <FormControl fullWidth>
                                        <TextField
                                          id="AirRouterCount"
                                          name="AirRouterCount"
                                          label="Hava Yönlendirici Adet"
                                          type="number"
                                          variant="outlined"
                                          disabled={
                                            !checkRolesAuth('AirRouterCount')
                                          }
                                          error={Boolean(
                                            errors[`AirRouterCount${item.Id}`]
                                          )}
                                          helperText={
                                            errors[`AirRouterCount${item.Id}`]
                                          }
                                          value={item.AirRouterCount}
                                          onChange={event =>
                                            handleChange(
                                              item.Id,
                                              'AirRouterCount',
                                              event.target.value,
                                              'text',
                                              dataMinValues?.find(
                                                x => x.Id === item.Id
                                              )?.AirRouterCount,
                                              'decreaseCheck'
                                            )
                                          }
                                        />
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Grid>

                          <Grid size={12}>
                            <Divider />
                          </Grid>
                          <Grid size={12}>
                            <FormControl fullWidth>
                              <TextField
                                id="SystemNote"
                                name="SystemNote"
                                variant="outlined"
                                disabled={!checkRolesAuth('SystemNote')}
                                multiline
                                minRows={3}
                                placeholder="Açıklama"
                                value={item.SystemNote}
                                onChange={event =>
                                  handleChange(
                                    item.Id,
                                    'SystemNote',
                                    event.target.value,
                                    'text'
                                  )
                                }
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  ))
              ) : (
                <></>
              )}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      {/* Modern Dosya Listesi Bölümü */}
      <FileUploadList
        projectFiles={projectFiles}
        setProjectFiles={setProjectFiles}
        fileTypes={fileTypes}
        data={data}
        handleDownload={handleDownload}
        fileLoading={fileLoading}
        checkRolesAuth={checkRolesAuth}
      />
      {/* Modern Yeni Dosya Ekleme Bölümü */}
      <FileUploadAdd
        projectFiles={projectFiles}
        setProjectFiles={setProjectFiles}
        fileTypes={fileTypes}
        data={data}
        handleFiles={handleFiles}
        handleAddFile={handleAddFile}
        checkRolesAuth={checkRolesAuth}
      />
    </React.Fragment>
  );
}

export default ProjectUpdate;
